import { useCallback, useState } from "react";

import { PromptVersion } from "@/types/apiGetters";

const useTemplateSubmit = (
  saveType: "update" | "create",
  newTemplateName: string,
  selectedTemplateId: number,
  handleCreate: (name: string, shouldUseSnippetOverrides?: boolean) => Promise<void>,
  handleUpdate: (
    id: number,
    data: {
      commitMessage?: string;
      evaluationId?: number;
    },
    shouldUseSnippetOverrides?: boolean,
  ) => Promise<PromptVersion>,
  isValid: () => boolean,
  setOpen: (open: boolean) => void,
  // eslint-disable-next-line max-params
) => {
  const [promptVersion, setPromptVersion] = useState<PromptVersion | null>();
  const submit = useCallback(
    (commitMessage?: string, evaluationId?: number, shouldUseSnippetOverrides?: boolean) => {
      if (!isValid()) {
        return;
      }

      if (saveType === "create" && newTemplateName) {
        void handleCreate(newTemplateName, shouldUseSnippetOverrides);
      } else if (saveType === "update" && selectedTemplateId) {
        handleUpdate(selectedTemplateId, { commitMessage, evaluationId }, shouldUseSnippetOverrides)
          .then(version => {
            setPromptVersion(version);
          })
          .catch();
      }
      setOpen(false);
    },
    [saveType, newTemplateName, selectedTemplateId, handleCreate, handleUpdate, isValid, setOpen],
  );
  return [promptVersion, submit] as const;
};

export default useTemplateSubmit;
